import { StaticLocationParamaters } from 'cg-foundation-theming';
var ComparePageController = (function () {
    function ComparePageController($scope, locationService, compareChannel, compareResult) {
        var _this = this;
        this.$scope = $scope;
        this.locationService = locationService;
        this.compareChannel = compareChannel;
        this.$scope.thirdPartyDevices = [];
        this.$scope.groups = [];
        if (compareResult !== undefined) {
            this.$scope.thirdPartyDevices = compareResult.thirdPartyProducts;
            this.$scope.groups = compareResult.products;
        }
        this.$scope.excludedThirdPartyDevices = this.locationService.get(StaticLocationParamaters.thirdPartyProducts, true);
        this.$scope.onGroupExcluded = function (group) {
            _this.compareChannel.remove(group);
            _this.locationService.delete(StaticLocationParamaters.products, group.searchKey);
        };
    }
    ComparePageController.$inject = ['$scope', 'locationService', 'compareChannel', 'compareResult'];
    return ComparePageController;
}());
export { ComparePageController };
